import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * Whether the site-wide header / footer should be hidden.
 *
 * The VIP personal area renders its own full-screen shell with its own top
 * bar (personal-shell, VIP branch). On those pages the site header would sit
 * on top of it as a second header, so the shell asks for it to be hidden
 * while it is shown and restores it when it goes away.
 */
@Injectable({ providedIn: 'root' })
export class SiteChromeService {
  private readonly hiddenSubject = new BehaviorSubject<boolean>(false);
  readonly hidden$ = this.hiddenSubject.pipe(distinctUntilChanged());

  /** Deferred a tick so it never changes a binding mid change-detection. */
  setHidden(hidden: boolean): void {
    Promise.resolve().then(() => this.hiddenSubject.next(hidden));
  }
}
